(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8141],{

/***/ 49286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chi-tiet-phan-anh/[...slug]",
      function () {
        return __webpack_require__(19126);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _common_hoc_ClientPage_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81346);
/* harmony import */ var _common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31691);




var ReflectDetail = (0,_common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4090), __webpack_require__.e(260), __webpack_require__.e(2580), __webpack_require__.e(4231), __webpack_require__.e(5808), __webpack_require__.e(2879), __webpack_require__.e(5162), __webpack_require__.e(7469)]).then(__webpack_require__.bind(__webpack_require__, 47469));
}, true);
/* harmony default export */ __webpack_exports__["default"] = ((0,_common_hoc_ClientPage_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReflectDetail, {});
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,4617,3874,4614,3376,1346,9774,2888,179], function() { return __webpack_exec__(49286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);